import styled from 'styled-components';
import {dFlex, dFlexColumn, flexWrap} from '../../../globalVariables/GlobalFlex';
import {dFlexCenter} from '../../../globalVariables/GlobalVariables';
import zIndex from '../../../globalVariables/zIndex';
import {text} from '../../../component/SMSCode/SMSCode.css';

export const wrapper = styled.div`
    ${dFlexColumn};
    width: 100%;
    padding: var(--space-xl) var(--space-md) var(--space-2xl);
    gap: var(--space-lg);
`;

export const title = styled.h2`
    margin: 0;
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-semibold);
    color: var(--color-brand-main);
`;

export const subtitle = styled.p`
    margin: 0;
    font-size: var(--font-size-body-small);
    line-height: var(--line-height-body, 1.4);
    color: var(--color-text-default);
`;

export const loaderOverlay = styled.div`
    position: absolute;
    inset: 0;
    ${dFlexCenter};
    background: var(--color-overlay-light);
    z-index: ${zIndex.baseHigh};
`;

export const actions = styled.div`
    ${dFlex};
    ${flexWrap};
    gap: var(--space-md);
    margin-top: var(--space-sm);
`;

export const errorText = styled.div`
    color: var(--color-state-error-main);
    font-size: var(--font-size-caption);
`;

/** Shared card container used across wizard steps. */
export const card = styled.div`
    ${dFlexColumn};
    padding: var(--space-xl);
    gap: var(--space-xl);
    border-radius: var(--space-md);
    background: var(--primitive-gray-100);
    ${text} {
        text-align: center;
    }
`;

export const dealTitle = styled.p`
    margin: 0;
    width: 100%;
    text-align: center;
    font-size: var(--font-size-heading-modal);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    color: var(--color-text-default);
`;

export const divider = styled.hr`
    width: 100%;
    border: none;
    border-top: 1px solid var(--color-border-subtle);
    margin: 0;
`;
